import { type CSSProperties } from 'react';
import { motion } from 'framer-motion';

export interface PreviewCardProps {
  label?: string;
  from: number | string;
  to: number | string;
  delta?: number;
  className?: string;
}

export const PreviewCard = ({ label, from, to, delta, className }: PreviewCardProps) => {
  const deltaValue = delta ?? (typeof to === 'number' && typeof from === 'number' ? to - from : undefined);
  const isNegative = typeof deltaValue === 'number' && deltaValue < 0;
  const deltaStyle: CSSProperties = {
    color: isNegative ? 'var(--badge-danger-fg)' : 'var(--badge-success-fg)',
    fontWeight: 600,
  };

  return (
    <motion.div
      className={`flex flex-col gap-1 p-4 ${className ?? ''}`}
      style={{
        background: 'linear-gradient(135deg, var(--surface-1) 0%, var(--surface-0) 100%)',
        borderRadius: 'var(--radius-card)',
        boxShadow: 'var(--shadow-card-rest)',
        border: '1px solid transparent',
        backgroundClip: 'padding-box',
      }}
      whileHover={{ boxShadow: 'var(--shadow-card-hover)' }}
      transition={{ duration: 0.2, ease: [0.16, 1, 0.3, 1] }}
    >
      {label ? (
        <span className="text-xs" style={{ color: 'var(--content-muted)' }}>{label}</span>
      ) : null}
      <div className="flex items-center gap-2 text-sm">
        <span style={{ color: 'var(--content-default)' }}>{from}</span>
        <span style={{ color: 'var(--content-muted)' }}>→</span>
        <span style={{ color: 'var(--content-strong)', fontWeight: 600 }}>{to}</span>
        {deltaValue !== undefined ? (
          <span style={deltaStyle}>
            {isNegative ? '' : '+'}{deltaValue}
          </span>
        ) : null}
      </div>
    </motion.div>
  );
};
